import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showIt)?_c(VBtn,{attrs:{"small":_vm.isSmall,"icon":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,{attrs:{"small":_vm.isSmall,"color":_vm.nowCoping?'red':''}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }